const imageTypes = ['jpg', 'png', 'jpeg', 'gif'];
export const isImageExt = (fileExt: string): boolean => {
  return imageTypes.includes(fileExt);
};

export const isImage = (file: File): boolean => {
  const type = file.type.split('/')[1] || file.type.split('/')[0];
  return isImageExt(type);
};
